// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2ixts","select":"Header_select__2wPk4","clinic":"Header_clinic__1M0Qv"};